import { FileService } from './file.service';

export const services = [
  FileService,
];
